var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-07-20
 * @brief SEI 설비유형 Management  개발
 *
 ********************************************************************/
import { useState } from "react";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { reLoad, userInfoLoginState } from "../../../../recoil/userState";
//utils
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import { alertState } from "../../../../recoil/assessmentState";
import { checkSheetState, compState, loadingBoxState, spgState } from "../../../../recoil/menuState";
import { useTrans } from "../../../../utils/langs/useTrans";
function SpgCreate(props) {
    const t = useTrans();
    //recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [checksheet, setCheckSheet] = useRecoilState(checkSheetState);
    const [spgs, setSpgs] = useRecoilState(spgState);
    const [spgNameEn, setSpgNameEn] = useState("");
    const [comps, setComps] = useRecoilState(compState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    //props
    const { checksheetName, setWorkMode } = props;
    //
    const [errorList, setErrorList] = useState([]);
    const [spgName, setSpgName] = useState("");
    const [elecinfo, setElecinfo] = useState([]);
    /*   var jobList = []
  
      for (let i = 0; i < 13; i++) {
          if (i < 9) {
              var jobinfo = {
                  dutyCodeId: i + 1,
                  name: "별지0" + (i + 1),
                  checkd: false
              }
          } else {
              var jobinfo = {
                  dutyCodeId: i + 1,
                  name: "별지" + (i + 1),
                  checkd: false
              }
          }
          jobList.push(jobinfo);
  
      } */
    // const [jobs, setJobs] = useState(jobList)
    //  설비 유형명
    function onChangeSpg(e) {
        setErrorList(errorList.filter((err) => err.field !== "spgName"));
        setSpgName(e.target.value);
    }
    function onChangeSpgEn(e) {
        setErrorList(errorList.filter((err) => err.field !== "spgNameEnglish"));
        setSpgNameEn(e.target.value);
    }
    // elecInfo add
    function ElecInfoAdd(e) {
        if (elecinfo.length < 30) {
            let val = {
                elecInfoName: "",
                elecInfoNameEnglish: "",
                unit: "",
                unitEn: "",
            };
            setElecinfo([...elecinfo, val]);
        }
        else {
            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: "초과 되었습니다." }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
    }
    // elec Info delete
    function ElecInfoDelete(index) {
        setElecinfo(elecinfo.filter((_, idx) => idx !== index));
    }
    // elec info name
    function ElecInfoName(e, index) {
        // setErrorList(errorList.filter((err) => (err.field !== "checkitemRef")))
        setElecinfo(elecinfo.map((smenu, idx) => (idx === index ? Object.assign(Object.assign({}, smenu), { elecInfoName: e.target.value }) : smenu)));
    }
    // elec info name
    function ElecInfoNameEn(e, index) {
        // setErrorList(errorList.filter((err) => (err.field !== "checkitemRef")))
        setElecinfo(elecinfo.map((smenu, idx) => (idx === index ? Object.assign(Object.assign({}, smenu), { elecInfoNameEnglish: e.target.value }) : smenu)));
    }
    // elec info unit
    function ElecInfoUnit(e, index) {
        // setErrorList(errorList.filter((err) => (err.field !== "checkitemRef")))
        setElecinfo(elecinfo.map((smenu, idx) => (idx === index ? Object.assign(Object.assign({}, smenu), { unit: e.target.value }) : smenu)));
    }
    // elec info unitEn
    function ElecInfoUnitEn(e, index) {
        // setErrorList(errorList.filter((err) => (err.field !== "checkitemRef")))
        setElecinfo(elecinfo.map((smenu, idx) => (idx === index ? Object.assign(Object.assign({}, smenu), { unitEn: e.target.value }) : smenu)));
    }
    /*     function checkedList(checked, index) {
  
          if (checked) {
              setJobs(
                  jobs.map((smenu, idx) => (idx === index)
                      ? { ...smenu, checked: checked }
                      : smenu
                  )
              );
          } else {
              setJobs(
                  jobs.map((smenu, idx) => (idx === index)
                      ? { ...smenu, checked: checked }
                      : smenu
                  )
              );
          }
      }; */
    // 설비 유형 등록
    function onClickSaved(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: "/product/company/spg",
                appQuery: {
                    companyId: comps.id,
                    spgName: spgName,
                    spgNameEnglish: spgNameEn,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    if (elecinfo.length > 0) {
                        ElecInfoCeatre(data.body);
                    }
                    else {
                        // if (jobs.filter((cked) => (cked.checked)).length > 0) {
                        //     Dutie(data.body)
                        // } else {
                        setReload(true);
                        setCheckSheet({
                            sheetType: checksheetName[1],
                            spgName: data.body.spgName,
                        });
                        setSpgs({
                            spgId: -1,
                            compSpgId: -1,
                            companySpgId: data.body.companySpgId,
                            spgName: data.body.spgName,
                        });
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: "설비유형이 등록되었습니다." }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setWorkMode("READ");
                        setReload(false);
                        setRecoilIsLoadingBox(false);
                        // }
                    }
                }
                else {
                    if (data.body.errorList.filter((err) => err.field == "spgName")) {
                        setErrorList(data.body.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.body.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    //elec info add
    function ElecInfoCeatre(info) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            var success = [];
            var fail = [];
            for (let i = 0; i < elecinfo.length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: "/product/company/spg/elecinfo",
                    appQuery: {
                        companySpgId: info.companySpgId,
                        elecInfoName: elecinfo[i].elecInfoName,
                        elecInfoNameEnglish: elecinfo[i].elecInfoNameEnglish,
                        unit: elecinfo[i].unit,
                        unitEn: elecinfo[i].unitEn,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        success.push(data.body);
                    }
                    else {
                        /*     let msg =data.errorList.map((err) => ({ ...err, no: i + 1 })) */
                        fail.push(data.errorList);
                    }
                }
            }
            if (data) {
                if (fail.length <= 0) {
                    // if (jobs.filter((cked) => (cked.checked)).length > 0) {
                    //     Dutie(info)
                    // } else {
                    setReload(true);
                    setCheckSheet({
                        sheetType: checksheetName[1],
                        spgName: info.spgName,
                    });
                    setSpgs({
                        spgId: -1,
                        compSpgId: -1,
                        companySpgId: info.companySpgId,
                        spgName: info.spgName,
                    });
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: "설비유형이 등록되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setWorkMode("READ");
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                    // }
                }
                else if (fail.length > 0) {
                    setReload(true);
                    setCheckSheet({
                        sheetType: checksheetName[1],
                        spgName: info.spgName,
                    });
                    setSpgs({
                        spgId: -1,
                        compSpgId: -1,
                        companySpgId: info.companySpgId,
                        spgName: info.spgName,
                    });
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, pTag: {
                            p1: `성공 ${success.length}건 입니다.`,
                            p2: `실패 ${fail.length}건 입니다.`,
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setWorkMode("READ");
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    /*     async function Dutie(info) {
          let data: any = null;
          data = await HTTPUTIL.PromiseHttp({
              "httpMethod": "GET",
              "appPath": `/product/company/spg/${info.companySpgId}/duties`,
              appQuery: {},
              userToken: userInfo.loginInfo.token,
          });
          if (data) {
              if (data.codeNum == CONST.API_200) {
                  let duty = []
                  jobs.filter((cked) => (cked.checked)).map((job) => (
                      data.body.dutyCode.filter((check) => (check.name == job.name)).map((list) => (
                          duty.push(list.id)
                      ))
                  ))
                  JobCeatre(info, duty)
              } else {
  
              }
          }
      } */
    /*     async function JobCeatre(info, list) {
  
          let data: any = null;
          data = await HTTPUTIL.PromiseHttp({
              "httpMethod": "POST",
              appPath: `/product/company/spg/${info.companySpgId}/duty`,
              appQuery: {
                  dutyCodeIds: list.map((item) => (item))
              },
              userToken: userInfo.loginInfo.token,
          });
  
          if (data) {
              if (data.codeNum == CONST.API_200) {
  
                  setRecoilIsLoadingBox(false);
                  setReload(true);
                  setCheckSheet({
                      sheetType: checksheetName[1],
                      spgName: info.spgName
                  });
                  setSpgs({
                      spgId: -1,
                      compSpgId: -1,
                      companySpgId: info.companySpgId,
                      spgName: info.spgName,
  
                  });
                  setAlert({
                      ...alert,
                      type: CONST.TYPE_ERROR,
                      divTag: "설비유형이 등록되었습니다.",
                  })
                  CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                  setWorkMode("READ");
                  setReload(false);
                  setRecoilIsLoadingBox(false);
  
              } else {
                  setAlert({
                      ...alert,
                      type: CONST.TYPE_ERROR,
                      divTag: "오류",
                  })
                  CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                  setRecoilIsLoadingBox(false);
              }
  
  
  
          }
      } */
    // 취소
    function onClickclose(e) {
        setReload(true);
        setWorkMode("READ");
        setReload(false);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "content-wrap " }, { children: [_jsx("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: _jsxs("h2", Object.assign({ className: "box__title" }, { children: [comps.companyName, " ", t("라벨.신규설비유형추가")] })) })), _jsx("div", Object.assign({ className: "box__body" }, { children: _jsx("div", Object.assign({ className: "content__info" }, { children: _jsxs("ul", { children: [_jsxs("li", { children: [_jsxs("div", Object.assign({ className: "flex-row center" }, { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.설비유형명") })), _jsxs("div", Object.assign({ className: "txt" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), className: `w254 ${errorList.filter((err) => err.field === "spgName").length > 0 ? " input-error" : ""}`, value: spgName, onChange: (e) => onChangeSpg(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "spgName").map((err) => err.msg) }))] }))] })), _jsxs("div", Object.assign({ className: "flex-row center ml-80" }, { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.설비유형영문명") })), _jsxs("div", Object.assign({ className: "txt" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), className: `w254 ${errorList.filter((err) => err.field === "spgNameEnglish").length > 0 ? " input-error" : ""}`, value: spgNameEn, onChange: (e) => onChangeSpgEn(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "spgNameEnglish").map((err) => err.msg) }))] }))] }))] }), _jsxs("li", Object.assign({ className: "mb-24" }, { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.ElecInfo설정") })), _jsx("div", Object.assign({ className: "tbl-list txt p-4" }, { children: _jsxs("table", Object.assign({ summary: "No., Elec Info \uBA85,\uB2E8\uC704,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C Elec Info \uC124\uC815 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "Elec Info \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "23%" } }), _jsx("col", { style: { width: "23%" } }), _jsx("col", { style: { width: "7%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "pl-22" }, { children: "No." })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.ElecInfo명") })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.영문명") })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.단위") })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uB2E8\uC704/\uC120\uD0DD \uC601\uBB38 \uBA85" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: t("라벨.삭제") }))] }) }), _jsxs("tbody", { children: [elecinfo.length > 0 ? (elecinfo.map((list, idx) => (_jsxs("tr", { children: [_jsx("td", Object.assign({ className: "pl-24" }, { children: idx + 1 })), _jsx("td", { children: _jsx("input", { type: "text", placeholder: `${t("라벨.예시")} 전력전압`, value: list.elecInfoName, onChange: (e) => ElecInfoName(e, idx) }) }), _jsx("td", { children: _jsx("input", { type: "text", placeholder: `${t("라벨.예시")} PowerVoltage`, value: list.elecInfoNameEnglish, onChange: (e) => ElecInfoNameEn(e, idx) }) }), _jsx("td", { children: _jsx("input", { type: "text", placeholder: `${t("라벨.예시")} kV`, value: list.unit, onChange: (e) => ElecInfoUnit(e, idx) }) }), _jsx("td", { children: _jsx("input", { type: "text", placeholder: "\uC601\uBB38\uC73C\uB85C \uC785\uB825\uD558\uC138\uC694.", value: list.unitEn, onChange: (e) => ElecInfoUnitEn(e, idx) }) }), _jsxs("td", { children: [" ", _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr ml-32 w32 h32", onClick: (e) => ElecInfoDelete(idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] })] }, "elecInfo_" + idx.toString())))) : (_jsx("tr", { children: _jsxs("td", Object.assign({ className: "txt-info", colSpan: 6 }, { children: ["* ", t("라벨.등록된내용이없습니다추가버튼을눌러ElecInfo를설정해주세요")] })) })), _jsx("tr", { children: _jsx("td", Object.assign({ colSpan: 6, className: "bg-no ph-8 " }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-add-wide", onClick: (e) => ElecInfoAdd(e) }, { children: _jsx("span", { children: t("라벨.추가") }) })) })) })] })] })) }))] })), _jsx("li", { children: _jsxs("div", Object.assign({ className: "btn__wrap" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", onClick: (e) => onClickclose(e) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic ", onClick: (e) => onClickSaved(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] })) })] }) })) }))] })) }));
}
export default SpgCreate;
